import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { AppState } from '../models';
import * as actions from '../actions';
import { PlanHolder, Beneficiary } from '../models/applicationForm';
import ApplicationForm from '../components/ApplicationForm/ApplicationForm';

export const mapStateToProps = (state: AppState) => state.applicationForm

export const mapDispatchToProps = (dispatch: Dispatch) => ({
  setPlanholder: (planholder: PlanHolder) => dispatch(
    actions.setPlanholder(planholder)
  ),
  setBeneficiary: (beneficiary: Beneficiary) => dispatch(
    actions.setBeneficiary(beneficiary)
  )
});

export default connect(mapStateToProps, mapDispatchToProps)(ApplicationForm);